import React from 'react';
import ActionItemDropdownList from './ActionItemDropdownList.mjs';
import './ActionItemListItem.css';
import { useCTAL } from './CTAL_Hooks.js';

export default function ActionItemListItemAssigned({action_item, active_text, displayActionItem}) 
{
    const { num_display_columns } = useCTAL(); 

    const display_action_item = () => { 
        //For Mobile Devices Don't go to Action-Item Detail Display
        if (num_display_columns > 1)
            displayActionItem(action_item);
    }

    var priority_icon_file = "./images/on-fire-col.svg";
    switch (action_item.Priority)
    {
        case "On-Fire": priority_icon_file = "./images/on-fire-col.svg"; break;
        case     "Hot": priority_icon_file = "./images/hot-col.svg";     break;
        case  "Normal": priority_icon_file = "./images/normal2-col.svg"; break;
        case     "Low": priority_icon_file = "./images/low2-col.svg";    break;
    }

    var action_number = action_item.Name;
    var action_name_parts = action_item.Name.split("-");
    if (action_name_parts.length > 1) action_number = action_name_parts[1];

    return (
        <>
            <div class="input-group input-group-sm mb-0">
                <span class="input-group-text" onClick={ () => displayActionItem(action_item) }><img src={priority_icon_file} alt={action_item.Priority} border="0"/> </span>

                <span id="assigned-action-item-name" class="input-group-text" onClick={ () => displayActionItem(action_item) }>{action_number}</span>
                
                <input type="text" class="form-control" value={action_item.Summary} readOnly aria-label="Action Summary" onClick={ () => display_action_item() } />
                
                <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"><img src="./images/more.svg" alt="more" border="0"/></button>
                <ActionItemDropdownList sel_action_item={action_item} />
            </div>
        </>
    );
}

/*
    9/11/2023 Removed Priority Icons for a wider Summary View

    9/5/2023 Removed Check-Boxes for Beta Release
    <div class="input-group-text">
        <input class="form-check-input mt-0" type="checkbox" value="" aria-label="Checkbox for following text input"/>
    </div>
*/